import { Theme, makeStyles } from '@material-ui/core';

export const useRegisterFormStyles = makeStyles((theme: Theme) => ({
    row: {
        marginBottom: '24px',
        width: '100%',
    },
    checkbox: {
        display: 'block',
        wordWrap: 'break-word',
        maxWidth: '280px',
    },
}));
